<template>
  <div class="view-product-checkout-layout">
    <div class="row pt-6 pb-2">
      <div class="col-sm-6 px-3 py-3">
        <div class="card-box" :class="{ selected: checkoutType === 'long' }">
          <div class="p-5">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                id="template-1"
                class="flex-fill fs-14"
                v-model="checkoutType"
                value="long"
              >
                Template 1
              </b-form-checkbox>
              <button-switch
                :options="[
                  { title: 'Desktop', value: 'desktop' },
                  { title: 'Mobile', value: 'mobile' }
                ]"
                v-model="defaultScreen"
              />
            </div>
            <div
              class="d-flex justify-content-center align-items-center svg-size"
            >
              <img
                v-if="defaultScreen === 'desktop'"
                src="@/assets/images/checkout-layout/template-1-desktop.svg"
                class="flex-fill pt-9"
              />
              <img
                v-if="defaultScreen === 'mobile'"
                src="@/assets/images/checkout-layout/template-1-mobile.svg"
                class="flex-fill pt-5"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 px-3 py-3">
        <div class="card-box" :class="{ selected: checkoutType === 'short' }">
          <div class="p-5">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                id="template-2"
                class="flex-fill fs-14"
                v-model="checkoutType"
                value="short"
              >
                Template 2
              </b-form-checkbox>
              <button-switch
                :options="[
                  { title: 'Desktop', value: 'desktop' },
                  { title: 'Mobile', value: 'mobile' }
                ]"
                v-model="longScreen"
              />
            </div>

            <div
              class="d-flex justify-content-center align-items-center svg-size"
            >
              <img
                v-if="longScreen === 'desktop'"
                src="@/assets/images/checkout-layout/template-2-desktop.svg"
                class="flex-fill pt-9"
              />
              <img
                v-if="longScreen === 'mobile'"
                src="@/assets/images/checkout-layout/template-2-mobile.svg"
                class="flex-fill pt-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <standard-checkout
      @cancel="standardCheckVisible = false"
      v-if="standardCheckVisible"
    />

    <checkout-builder
      v-if="customCheckVisible"
      :form="form"
      :loading="loading"
      @close="customCheckVisible = false"
      @save="onSubmit"
    />

    <!-- <div class="d-sm-flex d-none justify-content-between mt-9">
      <button
        type="button"
        class="btn d-flex btn-outline-secondary"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
      <div class="mx-3"></div>
      <button @click="$emit('next')" class="btn d-flex btn-new-primary">
        <loading :show="loading">
          Próximo
          <i class="icon-angle-right ml-3" />
        </loading>
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9 p-5">
      <button @click="$emit('next')" class="btn btn-block btn-new-primary">
        <loading :show="loading">
          Próximo
          <i class="icon-angle-right ml-3" />
        </loading>
      </button>
      <div class="m-3"></div>
      <button
        type="button"
        class="btn btn-block btn-outline-secondary"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
    </div> -->

    <div
      class="d-flex flex-column-reverse gap-5 flex-md-row justify-content-between mt-6"
    >
      <bp-button
        label="Voltar"
        color="neutral"
        icon="icon-angle-left"
        variant="filled-1"
        @click="$emit('cancel')"
      />

      <bp-button
        color="primary"
        trailingIcon="icon-angle-right"
        label="Próximo"
        type="submit"
        @click="$emit('next')"
      />
    </div>

    <modal-completed
      v-model="showSuccessModal"
      description="Suas alterações foram salvas com sucesso!"
      @action="showSuccessModal = false"
    />
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

import StandardCheckout from "@/components/product/checkout/StandardCheckout";
import CheckoutBuilder from "@/components/product/checkout/builder/CheckoutBuilder";

export default {
  components: {
    StandardCheckout,
    CheckoutBuilder
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      showSuccessModal: false,
      standardCheckVisible: false,
      customCheckVisible: false,
      defaultScreen: "desktop",
      longScreen: "desktop",
      ...formFields(["id", "type", "components", "config", "product_id"], {
        id: null,
        type: "default",
        components: [
          {
            type: "details",
            position: "side",
            config: {},
            id: 1620000000000 - Date.now(),
            order: 0
          }
        ],
        config: {
          longPage: true
        },
        product_id: this.product.id,
        ...this.product.checkout_build
      }),
      checkoutType: this.product?.checkout_build?.config?.longPage
        ? "long"
        : "short"
    };
  },
  watch: {
    checkoutType(newVal) {
      this.form.config.longPage = newVal === "long";
      this.onSubmit();
    }
  },
  methods: {
    submitSuccess() {
      this.$router.push({ name: "product-details" });
    },
    onSubmit() {
      this.loading = true;
      const action = this.form.id
        ? "checkoutBuilder/put"
        : "checkoutBuilder/post";

      const data = { ...this.form };
      data.config.longPage = this.checkoutType === "long";
      data.type = "custom";

      this.$store
        .dispatch(action, data)
        .then(response => {
          this.form = response.data;
          if (this.customCheckVisible) {
            this.showSuccessModal = true;
          }
        })
        .catch(error => {
          if (error.response.data.details) {
            this.$message.error(error.response.data.details);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-checkout-layout {
  .button-switch-component {
    height: 24px;

    ::v-deep .btn {
      font-size: 12px;
      font-weight: 500;
    }

    ::v-deep .btn-primary {
      background-color: #e4d2fe !important;
      color: #381c63 !important;
      min-height: 0px !important;
    }

    ::v-deep .btn-outline-secondary {
      color: #606065 !important;
    }
  }

  .svg-size {
    max-width: fit-content;
    margin: 0 auto;
  }

  img {
    width: -webkit-fill-available;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
}
</style>
